// Money — USDC / dollar formatter. Always mono, always tabular-nums,
// always $-prefixed. Use this primitive everywhere a dollar value
// renders so the seam stays consistent (welcome strip stats, order
// summary, distribution amounts, etc.).
//
// Format: `$ 12,500.00 USDC` — non-breaking space between $
// and digits keeps the prefix glued to the number even on tight
// wrapping. The bundle uses `$ 12,500.00 USDC` literally; we get
// the same visual via U+00A0.

export type MoneyProps = {
  value: number;
  unit?: 'USDC';
  precision?: number;
};

const fmt = (precision: number) =>
  new Intl.NumberFormat('en-US', {
    minimumFractionDigits: precision,
    maximumFractionDigits: precision,
  });

export function Money({ value, unit, precision = 2 }: MoneyProps) {
  const digits = fmt(precision).format(value);
  return (
    <span className="font-mono tabular-nums whitespace-nowrap text-foreground">
      {`$ ${digits}`}
      {unit ? <span className="ml-1">{unit}</span> : null}
    </span>
  );
}
